import { FORM_PROPERTIES, type FormPropertyName } from './formConfig';
import type { FieldErrors } from './types';

const HUBSPOT_PORTAL_ID = '7552465';

type HubspotError = {
  context?: {
    propertyName?: string[];
  };
  message?: string;
};

type HubspotErrorResponse = {
  errors?: HubspotError[];
  message?: string;
};

export const getHubspotSubmissionUrl = (formId: string): string =>
  `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${formId}`;

export const getHubspotCookie = (): string | undefined =>
  document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('hubspotutk='))
    ?.split('=')[1];

const isFormPropertyName = (value: string): value is FormPropertyName =>
  FORM_PROPERTIES.some((property) => property.name === value);

export const getSubmissionErrors = async (
  response: Response
): Promise<{ fieldErrors: FieldErrors; message?: string }> => {
  const rawBody = await response.text();
  let body: HubspotErrorResponse = {};

  try {
    body = JSON.parse(rawBody) as HubspotErrorResponse;
  } catch {
    return { fieldErrors: {}, message: rawBody || undefined };
  }

  const fieldErrors: FieldErrors = {};
  const messages: string[] = [];

  body.errors?.forEach((error) => {
    if (!error.message) return;
    messages.push(error.message);
    const propertyName = error.context?.propertyName?.[0];
    if (propertyName && isFormPropertyName(propertyName)) fieldErrors[propertyName] = error.message;
  });

  return {
    fieldErrors,
    message: messages[0] ?? body.message
  };
};

export { HUBSPOT_PORTAL_ID };
